import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    getStores: {},
    getChecklist: {},
    getScheduleData: {},
    getReScheduleHistory: {},
    checklistDate: {}
}

const checkListConfigSlice = createSlice({
    name: "checklistConfigWatcher",
    initialState,
    reducers: {
        saveGetChecklistStore: (state, action) => {
            return { ...state, getStores: action?.payload }
        },
        saveGetChecklist: (state, action) => {
            const checkList = action?.payload?.map((item) => ({ ...item, checked: false }))
            return { ...state, getChecklist: checkList }
        },
        saveIsChecked: (state, action) => {
            const checkedChecklistData = state?.getChecklist?.map((item) => {
                if (item?.id == action?.payload) {
                    return { ...item, checked: !item?.checked }
                }
                return item
            })
            return { ...state, getChecklist: checkedChecklistData }
        },
        saveGetScheduleData: (state, action) => {
            return { ...state, getScheduleData: action?.payload }
        },
        saveReScheduleHistory: (state, action) => {
            return { ...state, getReScheduleHistory: action?.payload }
        },
        saveChecklistDatePreserve: (state, action) => {
            return { ...state, getChecklist: action?.payload }
        }
    }
})

export const { saveChecklistDatePreserve, saveReScheduleHistory, saveGetScheduleData, saveGetChecklistStore, saveGetChecklist, saveIsChecked } = checkListConfigSlice.actions;
export default checkListConfigSlice.reducer;